module.exports = __webpack_public_path__ + "img/football-field.cbe993cf.svg";